var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4844 12.5312L12.2812 17.7695C12.1055 17.9453 11.8594 17.9453 11.6836 17.7695L6.48047 12.5312C6.30469 12.3906 6.30469 12.1094 6.48047 11.9336L6.72656 11.6875C6.90234 11.5469 7.14844 11.5469 7.32422 11.6875L11.4023 15.7656V4.79688C11.4023 4.58594 11.5781 4.375 11.8242 4.375H12.1758C12.3867 4.375 12.5977 4.58594 12.5977 4.79688V15.7656L16.6406 11.6875C16.8164 11.5469 17.0625 11.5469 17.2383 11.6875L17.4844 11.9688C17.6602 12.1094 17.6602 12.3906 17.4844 12.5312ZM18.75 19.7031C18.75 19.9492 18.5391 20.125 18.3281 20.125H5.67188C5.42578 20.125 5.25 19.9492 5.25 19.7031V19.4219C5.25 19.2109 5.42578 19 5.67188 19H18.3281C18.5391 19 18.75 19.2109 18.75 19.4219V19.7031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.bbdf31b8.svg";
export { ForwardRef as ReactComponent };